
/**
 * Format a value for y-axis display based on the unit
 */
export function formatYAxisTick(value: number, unit: string): string {
  if (isNaN(value)) return '0';
  
  // Format based on unit type
  if (isMetricUnit(unit)) {
    // For metric units, show whole numbers for larger values
    return value >= 100 ? Math.round(value).toString() : value.toFixed(1);
  } else {
    // For imperial units, always use 1 decimal place
    return value.toFixed(1);
  }
}

/**
 * Check if a unit is metric (cm or g)
 */
export function isMetricUnit(unit: string): boolean {
  return unit === 'cm' || unit === 'g';
}
